import React from "react"
import atomize from "@quarkly/atomize"
import ProtectedEmail from "./ProtectedEmail"

const PrivacyPolicy = ({ lang = "en", ...props }) => {
  if (lang === "ja") {
    return (
      <div
        className="legal-document"
        {...props}
        style={{
          maxWidth: 800,
          margin: "auto",
        }}
      >
        <p className="title">
          <strong>プライバシーポリシー</strong>
        </p>

        <p className="subtitle">
          <strong>最終更新日：2026年6月4日</strong>
        </p>

        <p className="body_text">
          Atelier
          α（以下「当スタジオ」または「当方」）は、お客様の個人情報の保護を極めて重要と認識しております。本プライバシーポリシーは、当ウェブサイトおよび提供するサービス（以下「本サービス」）において、お客様から取得する個人情報（バイオメトリックデータおよび生理的データを含みます）の取り扱いについて説明するものです。
        </p>

        <p className="heading_1">
          <strong>1. 取得する情報</strong>
        </p>
        <p className="body_text">
          当スタジオは、以下の情報を取得および処理する場合があります。
        </p>
        <ul>
          <li className="body_text">
            <strong>お問い合わせおよび連絡先情報:</strong>{" "}
            お名前、メールアドレス、電話番号、会社名、お問い合わせ内容など。
          </li>
          <li className="body_text">
            <strong>
              生理学的およびバイオメトリックデータ（EEG/視線計測データ）:
            </strong>{" "}
            空間診断サービスを利用される際、ウェアラブルセンサーおよび脳波計（EEG）、視線計測カメラ等を通じて収集される、脳波データ（注意、リラックス度、没入度等）および視線・停留パターン。
          </li>
          <li className="body_text">
            <strong>アクセスログおよびデバイス情報:</strong>{" "}
            IPアドレス、ブラウザの種類、オペレーティングシステム、言語設定、閲覧したページの履歴、Cookie情報など。
          </li>
        </ul>

        <p className="heading_1">
          <strong>2. 情報の利用目的</strong>
        </p>
        <p className="body_text">
          取得した個人情報は、以下の目的のためにのみ利用します。
        </p>
        <ul>
          <li className="body_text">
            当スタジオサービスに関するお問い合わせやご相談への回答
          </li>
          <li className="body_text">
            EEG等の測定データを活用した空間設計の分析および最適化提案
          </li>
          <li className="body_text">
            お客様の同意に基づく、脳波データおよび認知反応データの学術研究、ならびに空間調律アルゴリズムの向上（データは完全に匿名化されます）
          </li>
          <li className="body_text">
            当サービスおよびウェブサイトのセキュリティ確保と品質向上のための分析
          </li>
        </ul>

        <p className="heading_1">
          <strong>3. 個人情報の安全管理と保管期間</strong>
        </p>
        <p className="body_text">
          当スタジオは、個人情報の紛失、改ざん、漏洩等を防ぐため、適切な物理的および電子的な管理体制を講じます。特に脳波計や視線計測から得られる生理データは、完全に匿名化された状態で処理され、プライバシー保護に細心の注意を払います。個人情報は、収集目的に必要な期間、または適用される法令で要求される期間のみ保持されます。
        </p>

        <p className="heading_1">
          <strong>4. 第三者への開示・提供の制限</strong>
        </p>
        <p className="body_text">
          当スタジオは、次のいずれかに該当する場合を除き、お客様の同意を得ずに個人情報を第三者に提供または開示することはありません。
        </p>
        <ul>
          <li className="body_text">お客様の同意がある場合</li>
          <li className="body_text">
            統計的なデータなど、個人を識別できない状態で開示する場合
          </li>
          <li className="body_text">法令に基づき開示が必要とされる場合</li>
          <li className="body_text">
            当方と機密保持契約を締結している信頼できる業務委託先（分析システム提供会社など）に必要な範囲で委託する場合
          </li>
        </ul>

        <p className="heading_1">
          <strong>5. クッキー（Cookie）について</strong>
        </p>
        <p className="body_text">
          当ウェブサイトは、ユーザー体験の向上およびサイト利用状況の把握のためにCookieを使用することがあります。お客様はブラウザの設定によってCookieの受け取りを拒否することができますが、その場合、一部の機能が正しく動作しない可能性があります。
        </p>

        <p className="heading_1">
          <strong>6. 個人情報の開示・訂正・削除の権利</strong>
        </p>
        <p className="body_text">
          お客様は、当スタジオが保有するご自身の個人情報について、開示、訂正、追加、削除、または利用停止を求める権利を有します。これらの手続きを希望される場合は、下記のお問い合わせ先までご連絡ください。ご本人確認を行った上で、合理的な期間内に迅速に対応いたします。
        </p>

        <p className="heading_1">
          <strong>7. お問い合わせ先</strong>
        </p>
        <p className="body_text">
          個人情報の取扱いに関するご質問、または権利行使の申請は下記までご連絡ください。
          <br />
          <strong>
            <ProtectedEmail
              user="info"
              domain="myarchitecthelp.com"
              className="link"
            />
          </strong>
        </p>
      </div>
    )
  }

  return (
    <div
      className="legal-document"
      {...props}
      style={{
        maxWidth: 800,
        margin: "auto",
      }}
    >
      <p className="title">
        <strong>PRIVACY POLICY</strong>
      </p>

      <p className="subtitle">
        <strong>Last updated: June 4, 2026</strong>
      </p>

      <p className="body_text">
        Atelier α (&quot;we&quot;, &quot;us&quot;, or &quot;our&quot;) is
        committed to protecting your privacy. This Privacy Policy describes how
        we collect, use, store, and share information when you use our website
        and services (&quot;Services&quot;), especially in connection with our
        brainwave spatial measurement and design consultation.
      </p>

      <p className="heading_1">
        <strong>1. Information We Collect</strong>
      </p>
      <p className="body_text">
        We may collect the following types of information:
      </p>
      <ul>
        <li className="body_text">
          <strong>Contact Information:</strong> Your name, email address, phone
          number, company name, and message details provided when contacting us.
        </li>
        <li className="body_text">
          <strong>
            Physiological & Biometric Data (EEG and Eye-Tracking):
          </strong>{" "}
          When participating in our spatial diagnostics, we collect brainwave
          signals (EEG) indicating attention levels, relaxation, and cognitive
          load, along with eye-tracking gaze patterns and dwell durations.
        </li>
        <li className="body_text">
          <strong>Usage & Device Data:</strong> IP address, browser type,
          operating system, referred URL, cookies, and page navigation history
          when visiting our website.
        </li>
      </ul>

      <p className="heading_1">
        <strong>2. How We Use Your Information</strong>
      </p>
      <p className="body_text">We use the collected information to:</p>
      <ul>
        <li className="body_text">
          Respond to inquiries and communicate regarding project consultations.
        </li>
        <li className="body_text">
          Analyze spatial comfort levels and generate architectural optimization
          designs.
        </li>
        <li className="body_text">
          Conduct academic research and improve our cognitive design algorithms.
          In such cases, all physiological data is fully and strictly
          anonymized.
        </li>
        <li className="body_text">
          Ensure the security, stability, and proper operation of our website
          and systems.
        </li>
      </ul>

      <p className="heading_1">
        <strong>3. Data Protection and Retention</strong>
      </p>
      <p className="body_text">
        We implement appropriate technical and organizational measures to
        prevent unauthorized access, loss, alteration, or disclosure of your
        personal data. Biosignals (EEG and gaze data) are stored and analyzed
        under strict anonymity to protect participant identity. Personal data is
        retained only as long as necessary to fulfill the purposes of collection
        or as mandated by legal frameworks.
      </p>

      <p className="heading_1">
        <strong>4. Sharing of Data</strong>
      </p>
      <p className="body_text">
        We do not sell or lease your personal information. Your data is only
        shared with third parties under the following conditions:
      </p>
      <ul>
        <li className="body_text">With your explicit prior consent.</li>
        <li className="body_text">
          As fully anonymized aggregated data for academic publications or
          research reports.
        </li>
        <li className="body_text">
          When legally required by public authorities or judicial actions.
        </li>
        <li className="body_text">
          With trusted contractors and software tools under confidentiality
          agreements to help operate our analysis systems.
        </li>
      </ul>

      <p className="heading_1">
        <strong>5. Cookies and Web Analytics</strong>
      </p>
      <p className="body_text">
        We use cookies to compile aggregate data about site traffic and user
        interactions to offer better experiences. You can choose to disable
        cookies through your individual browser settings, though some page
        functionalities may be affected.
      </p>

      <p className="heading_1">
        <strong>6. Your Privacy Rights</strong>
      </p>
      <p className="body_text">
        You have the right to request access to, correction, update, or deletion
        of your personal information held by Atelier α. If you wish to execute
        any of these rights, please reach out to us using the contact details
        below. We will verify your identity and address your request promptly.
      </p>

      <p className="heading_1">
        <strong>7. Contact Us</strong>
      </p>
      <p className="body_text">
        If you have questions or concerns regarding this Privacy Policy, please
        contact us at:
        <br />
        <strong>
          <ProtectedEmail
            user="info"
            domain="myarchitecthelp.com"
            className="link"
          />
        </strong>
      </p>
    </div>
  )
}

export default atomize(PrivacyPolicy)({
  name: "PrivacyPolicy",
  effects: {
    hover: ":hover",
  },
  normalize: true,
  mixins: true,
  description: {
    en: "PrivacyPolicy Component",
  },
  propInfo: {},
})
